module.exports = __webpack_public_path__ + "img/logo-white.9ff11957.png";